<template>
      <div>

      </div>
</template>

<script>
  import axios from 'axios';
  import storage from '@/utils/storage'
  import router from '../../router/index.js'
  export default {
    name: 'transfer',
    data(){
      return{
        membersign:'',
        referer:'',
        // isnew:'',
      }
    },
    created(){
      var self=this;
      var urlparam = self.$route.query;
      self.membersign = urlparam.membersign;
    },
    mounted(){
      // alert('is in transfer')
       // this.gettoken();
       // console.log(location.origin)
      // if(storage.get('masterPartnerUrlVal')){
      //   let url = storage.get('masterPartnerUrlVal')
      //   storage.remove('masterPartnerUrl')
      //   // alert(storage.get('masterPartnerUrl').split('/#')[1])
      //   // window.location.replace(storage.get('masterPartnerUrl'))
      //   // alert(url.split('/#')[1])
      //   this.$router.replace(url.split('/#')[1])
      // }
    },
    methods:{
      gettoken:function(){
        var self = this;
        // alert('66')
        axios.post('/v1/user/token/get', {
          member_sign:self.membersign
        })
        .then(function (res) {
          if(res.data.code == 200){
            var token = res.data.data.token;
            //新获取的token  7天后过期
            const expiredTime = new Date().getTime()+25200000,
            epoqueToken = {"content":token, "expiredTime":expiredTime };
            localStorage.setItem("epoqueToken", JSON.stringify(epoqueToken));
            store.state.islogin=res.data.data.is_new;
            store.state.referer=res.data.data.referer;
            if(res.data.data.referer == ''){
              // alert('7')
              referer = "/"
            }else{
              // alert('8')
              referer = res.data.data.referer
            }
            //去掉重定向后的时间戳
            location.replace(location.protocol+'//'+location.host+'/#'+referer);  
          }
        }) 
      }
    },
    route: {
      canReuse: false,
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/common/transfer.vue